export default __webpack_public_path__ + "static/media/480_portfolio04-it-mobile.75e90d95.png";